import { children, JSXElement } from "solid-js"
import './st-button-group.css'

export class STButtonGroupProps {
    children: JSXElement;
    vertical?: boolean;
}

export default function ButtonGroup(props: STButtonGroupProps) {
    const content = children(() => props.children)

    return <div class={`flexbox ${props.vertical ? 'vertical' : 'horizontal'} middle st-btn-group`}>
        {content()}
    </div>
}

ButtonGroup.defaultProps = new STButtonGroupProps();